import React from 'react'
import cn from 'classnames'
import { InView } from 'react-intersection-observer'
import { useAppSelector } from 'reduxTyped'
import { Lozenge, l } from '@manychat/manyui'

import { billing, UpgradeSource } from 'common/billing'
import { getHasBillingAccess } from 'common/billing/entities/miscellaneous/selectors'
import { IButton } from 'common/builder/buttons/buttonInterfaces'
import { isUrlButton } from 'common/builder/buttons/buttonTypeHelpers'
import { NodeType } from 'common/builder/constants/NodeType'
import { getIsPro } from 'common/core/selectors/appSelectors'
import { analyticsService } from 'utils/services/analytics'

import cm from './ButtonFormPoweredByMcBlock.module.css'

interface Props {
  button: IButton
  parentNodeType: NodeType
}

const availableChannels = [NodeType.INSTAGRAM, NodeType.WHATS_APP, NodeType.CONTENT]

export const ButtonFormPoweredByMcBlock = ({ button, parentNodeType }: Props) => {
  const hasBillingAccess = useAppSelector(getHasBillingAccess)
  const isPro = useAppSelector(getIsPro)

  if (isPro || !availableChannels.includes(parentNodeType) || !isUrlButton(button)) return null

  const handleInViewChange = (isInView: boolean) => {
    if (isInView) analyticsService.sendEvent('BUILDER.SIDEBAR.POWERED_BY_MC.SHOW')
  }

  const handleUpgradeToProClick = () => {
    billing.requestUpgrade({
      source: UpgradeSource.URL_BUTTON_POWERED_BY_MC,
    })
  }

  return (
    <InView
      as="div"
      className={cn('m-t-md p-a', cm.urlButtonPoweredByManychat)}
      onChange={handleInViewChange}
      threshold={0.8}
      triggerOnce
    >
      <Lozenge type="pro" className="m-b-xs" />
      <div>
        {hasBillingAccess ? (
          <>
            <span>{l.translate('People will see a redirection page for 2 seconds. ')}</span>
            <a className="text-primary c-pointer" onClick={handleUpgradeToProClick}>
              {l.translate('Upgrade to PRO')}
            </a>
            <span>{l.translate('<l10n context="Upgrade to Pro"/> to remove it.')}</span>
          </>
        ) : (
          l.translate(
            'People will see a redirection page for 2 seconds. Ask your admin to get PRO to remove it.',
          )
        )}
      </div>
    </InView>
  )
}
